<template>
  <div class="home">
    <!-- 今日流量 -->
    <div class="Row">
      <div class="flex-row-start">
        <div class="xiaobiao"></div>
        <div class="title">今日流量</div>
      </div>
      <div class="hh"></div>
      <!-- <hr> -->
      <div class="main">
        <ul class="row-ul">
          <li></li>
          <li>今日</li>
          <li>昨日</li>
          <li>预计今日</li>
        </ul>
        <div class="fx"></div>
        <ul class="row-ul row-num">
          <li>浏览量</li>
          <li>{{ today.pvC }}</li>
          <li>{{ yestoday.pvC }}</li>
          <li>
            {{ computedToday.pvC }}
            <img
              src="../../images/icons/up.png"
              alt=""
              v-if="yestoday.pvC < computedToday.pvC"
            />
            <img src="../../images/icons/down.png" alt="" v-else />
          </li>
        </ul>
        <div class="fx"></div>
        <ul class="row-ul row-num">
          <li>访客量</li>
          <li>{{ today.uvC }}</li>
          <li>{{ yestoday.uvC }}</li>
          <li>
            {{ computedToday.uvC }}
            <img
              src="../../images/icons/up.png"
              alt=""
              v-if="yestoday.uvC < computedToday.uvC"
            />
            <img src="../../images/icons/down.png" alt="" v-else />
          </li>
        </ul>
        <div class="fx"></div>
        <ul class="row-ul row-num">
          <li>IP数</li>
          <li>{{ today.ipC }}</li>
          <li>{{ yestoday.ipC }}</li>
          <li>
            {{ computedToday.ipC }}
            <img
              src="../../images/icons/up.png"
              alt=""
              v-if="yestoday.ipC < computedToday.ipC"
            />
            <img src="../../images/icons/down.png" alt="" v-else />
          </li>
        </ul>
        <div class="fx"></div>
        <ul class="row-ul row-num">
          <li>跳出率</li>
          <li>{{ today.jumpRate }}</li>
          <li>{{ yestoday.jumpRate }}</li>
          <li>
            {{ computedToday.jumpRate }}
            <img
              src="../../images/icons/up.png"
              alt=""
              v-if="yestoday.jumpRate < computedToday.jumpRate"
            />
            <img src="../../images/icons/down.png" alt="" v-else />
          </li>
        </ul>
        <div class="fx"></div>
        <ul class="row-ul row-num">
          <li>平均访问时长</li>
          <li>{{ today.time }}</li>
          <li>{{ yestoday.time }}</li>
          <li>
            {{ computedToday.time }}
            <img
              src="../../images/icons/up.png"
              alt=""
              v-if="yestoday.time < computedToday.time"
            />
            <img src="../../images/icons/down.png" alt="" v-else />
          </li>
        </ul>
      </div>
    </div>
    <div class="botton">
      <!-- 趋势图 -->
      <div class="trend">
        <div class="heard">
          <div class="flex-row-start">
            <div class="xiaobiao"></div>
            <div class="title">趋势图</div>
          </div>

          <el-select v-model="value" placeholder="7 天" @change="changtime">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </div>
        <div class="xiahuaixan"></div>
        <div class="trend-title">
          <ul class="trend-ul">
            <li :class="changpvid == 1 ? 'active' : ''" @click="changpv(1)">
              浏览量(PV)
            </li>
            <li
              :class="changpvid == 2 ? 'active' : ''"
              @click="changpv(2)"
            >
              访客数(UV)
            </li>
            <!-- <li>其他<i class="el-icon-arrow-down"></i></li> -->
          </ul>
          <div class="right">
            <div class="sgin">对比:</div>
            <el-radio v-model="radio" label="1" v-if="value == '1'"
              >昨天</el-radio
            >
            <el-radio v-model="radio" label="1" v-if="value == '2'"
              >前7天</el-radio
            >
            <el-radio v-model="radio" label="1" v-if="value == '3'"
              >上个月</el-radio
            >
            <!-- <el-radio v-model="radio" label="1" v-if="value =='3'">前30天</el-radio> -->
            <!-- <el-checkbox v-model="checked" :max="1" cl v-if="value =='1'">前一日</el-checkbox>
            <el-checkbox v-model="checked" :max="1" cl v-if="value =='2'">前7天</el-checkbox>
            <el-checkbox v-model="checked" :max="1" cl v-if="value =='3'">前30天</el-checkbox> -->
          </div>
        </div>
        <div style="width: 700px; height: 400px" class="trendMain"></div>
      </div>
      <!-- Top10热搜词 -->
      <div class="HotList">
        <div class="heard">
          <div class="flex-row-start">
            <div class="xiaobiao"></div>
            <div class="title">Top10搜索词</div>
          </div>
        </div>
        <div class="xiahuaixan"></div>
        <div class="Hotlist-main">
          <ul class="hotlist-ul">
            <li class="top">
              <div class="seachname">搜索词</div>
              <div class="looknumt">浏览量(PV)</div>
            </li>
            <div
              class="flex-row-center-start-space-between rankli"
              v-for="(item, index) in ranklist"
              :key="index"
            >
              <div class="" v-html="showcontent(item.name)"></div>
              <div class="item-value">{{ item.value }}</div>
            </div>
            <!-- <li class="top">
              <div class="seachname">热搜词</div>
              <div class="looknumt">浏览量(PV)</div>
            </li>
            <li>
              <div class="seachname">热搜词</div>
              <div class="looknum">浏览量(PV)</div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showcontent } from "@/utils/method.js";
export default {
  name: "home",
  data() {
    return {
      //yitian
      time1: [],
      name1: [],
      name2: [],
      aa: [],
      bb: [],
      aaa: [],
      bbb: [],
      ranklist: [],
      sevenpv: [],
      sevenpv2: [],
      sevenpvv: [],
      sevenpvv2: [],
      sevenpvv1: [],
      thirstypv: [],
      thirstypv1: [],
      thirstypv11: [],
      thirstypv2: [],
      thirstypv22: [],
      sixtypv: [],
      sevenpv1: [],
      onetimepv: [],
      onetimeuv: [],
      onetimepvv: [],
      onetimeuvv: [],
      radio: "1",
      changpvid: 1,
      today: {
        pvC: 0,
        uvC: 0,
        ipC: 0,
        jumpRate: 0,
        time: 0,
      },
      yestoday: {
        pvC: 0,
        uvC: 0,
        ipC: 0,
        jumpRate: 0,
        time: 0,
      },
      computedToday: {
        pvC: 0,
        uvC: 0,
        ipC: 0,
        jumpRate: 0,
        time: 0,
      },
      checked: true,
      options: [
        {
          value: "1",
          label: "1 天",
        },
        {
          value: "2",
          label: "7 天",
        },
        {
          value: "3",
          label: "30 天",
        },
      ],
      value: "1",
      hotList: [],
    };
  },
  mounted() {
    this.getinfo();
    this.getrank();
  },
  created() {},
  methods: {
    showcontent,
    changtime() {
      this.changpvid = 1;
      if (this.value == "2") {
        let a = [];
        this.sevenpv = [];
        this.sevenpvv = [];
        this.sevenpv1 = [];
        this.sevenpv2 = [];
        this.sevenpvv1 = [];
        this.sevenpvv2 = [];
        // console.log(this.thirstypv);
        //     let b = []
        for (const key in this.thirstypv) {
          a.push(this.thirstypv[key]);
        }
        a.reverse().forEach((e, index) => {
          if (index <= 59 && index >=53) {
            this.sevenpv.push(e);
          } else if (index >= 46 && index <= 52) {
            this.sevenpvv.push(e);
          }
        });
          console.log(a);
        this.sevenpv.forEach((res) => {
          this.sevenpv1.push(res["1"].pvCount);
          this.sevenpv2.push(res["1"].uvCount);
        });
        this.sevenpvv.forEach((res) => {
          this.sevenpvv1.push(res["1"].pvCount);
          this.sevenpvv2.push(res["1"].uvCount);
        });
        this.echartInit(this.sevenpv1, this.sevenpvv1);
        // console.log(this.sevenpvv2);
      } else if (this.value == "3") {
        let a = [];
        for (const key in this.thirstypv) {
          a.push(this.thirstypv[key]);
        }
        a.reverse().forEach((e, index) => {
          // console.log(a);
          if (index <= 29) {
            this.thirstypv11.push(e["1"].pvCount);
            this.thirstypv22.push(e["1"].uvCount);
          } else if (index >= 30 && index <= 59) {
            this.thirstypv1.push(e["1"].pvCount);
            this.thirstypv2.push(e["1"].uvCount);
          }
          // this.thirstypv1.push(e["1"].pvCount);
          // this.thirstypv2.push(e["1"].uvCount);
        });
        this.echartInit(this.thirstypv1, this.thirstypv11);
      } else {
        this.echartInit(this.aa, this.bb);
      }
    },
    changpv(id) {
      this.changpvid = id;
      if (id == 1 && this.value == "2") {
        this.echartInit(this.sevenpv1, this.sevenpvv1);
      } else if (id == 1 && this.value == "3") {
        this.echartInit(this.thirstypv1, this.thirstypv11);
      } else if (id == 1 && this.value == "1") {
        this.echartInit(this.aa, this.bb);
      } else if (id == 2 && this.value == "1") {
        this.echartInit(this.aaa, this.bbb);
      } else if (id == 2 && this.value == "2") {
        this.echartInit(this.sevenpv2, this.sevenpvv2);
      } else if (id == 2 && this.value == "3") {
        this.echartInit(this.thirstypv2, this.thirstypv22);
      }
    },
    //获取排行榜
    getrank() {
      this.$ajaxGet(`/mongoStatistic/getRanking`).then(({ data }) => {
        for (const key in data.data) {
          let parm = {};
          parm.name = key;
          parm.value = data.data[key];
          this.ranklist.push(parm);
        }
        let desec = function (a, b) {
          return b.value - a.value;
        }; //对处理后的数据进行升序处理
        this.ranklist.sort(desec);
        // console.log(this.ranklist);
      });
    },
    getinfo() {
      this.$http({
        url: this.$http.adornUrl("/mongoStatistic/getPvUv"),
        method: "get",
      }).then(({ data }) => {
        //一天
        this.onetimepv = data.data.todayDetail.pvCount;
        this.onetimeuv = data.data.todayDetail.uvCount;
        this.onetimepvv = data.data.yesterdayDetail.pvCount;
        this.onetimeuvv = data.data.yesterdayDetail.uvCount;
        this.thirstypv = data.data.recent60Days;
        this.sixtypv = data.data.recent60Days;
        //先把获取到的json对象转成map
        let map = new Map();
        //archive就是接口返回的json对象
        for (let year in this.thirstypv) {
          map.set(year, this.thirstypv[year]);
          // map.push(year, this.thirstypv[year])
        }

        //把map转换为array就可以排序了
        let arr = Array.from(map);
        arr.sort(function (a, b) {
          //map转成array后，下标0为key，下标1为value
          //这里根据年份进行倒序排序
          return b[0] - a[0];
        });
        this.thirstypv = arr;
        // console.log((this.thirstypv));
        let a = [];
        let b = [];
        let aa = [];
        let bb = [];
        for (const key in this.onetimepv) {
          a.push(this.onetimepv[key]);
        }
        for (const key in this.onetimepvv) {
          b.push(this.onetimepvv[key]);
        }
        for (const key in this.onetimeuv) {
          aa.push(this.onetimeuv[key]);
        }
        for (const key in this.onetimeuvv) {
          bb.push(this.onetimeuvv[key]);
        }
        this.aa = a;
        this.bb = b;
        this.aaa = aa;
        this.bbb = bb;
        // console.log(this.thirstypv);
        this.echartInit(a, b);
        // console.log(this.onetimepv );
        this.computedToday.pvC = data.data.forecastToday.pvCount;
        this.computedToday.ipC = data.data.forecastToday.ipCount;
        this.computedToday.uvC = data.data.forecastToday.uvCount;
        // this.computedToday.time = (
        //   Number(data.data.forecastToday.averageStaySeconds) / 3600
        // ).toFixed(2);
        // 用户输入任意秒数, 函数计算该毫秒数对应的时分秒, 并返回
        let second = data.data.forecastToday.averageStaySeconds;
        function getTime(time) {
          // 转换为式分秒
          let h = parseInt((time / 60 / 60) % 24);
          h = h < 10 ? "0" + h : h;
          let m = parseInt((time / 60) % 60);
          m = m < 10 ? "0" + m : m;
          let s = parseInt(time % 60);
          s = s < 10 ? "0" + s : s;
          // 作为返回值返回
          return [h, m, s];
        }
        let res = getTime(second);
        this.computedToday.time = `${res[0]}:${res[1]}:${res[2]}`;
        // console.log(`输入的秒数是${second}：，转换后是${res[0]}:${res[1]}:${res[2]}秒`)
        this.computedToday.jumpRate =
          data.data.forecastToday.jumpRate.toFixed(2);
        // debugger
        this.today.pvC = this.thirstypv[0][1].pvCount;
        this.today.uvC = this.thirstypv[0][1].uvCount;

        // this.today.uvC = data.data.todayDetail.uvCount;
        this.today.ipC = data.data.todayDetail.ipCount;
        this.today.jumpRate = data.data.todayDetail.jumpRate.toFixed(2);
        // this.today.time = (
        //   Number(data.data.todayDetail.averageStaySeconds) / 3600
        // ).toFixed(2);
        let second1 = data.data.todayDetail.averageStaySeconds;
        function getTime(time) {
          // 转换为式分秒
          let h = parseInt((time / 60 / 60) % 24);
          h = h < 10 ? "0" + h : h;
          let m = parseInt((time / 60) % 60);
          m = m < 10 ? "0" + m : m;
          let s = parseInt(time % 60);
          s = s < 10 ? "0" + s : s;
          // 作为返回值返回
          return [h, m, s];
        }
        let resss = getTime(second1);
        this.today.time = `${resss[0]}:${resss[1]}:${resss[2]}`;
        this.yestoday.pvC = this.thirstypv[1][1].pvCount;
        this.yestoday.uvC = this.thirstypv[1][1].uvCount;

        // this.yestoday.uvC = data.data.yesterdayDetail.uvCount;
        this.yestoday.ipC = data.data.yesterdayDetail.ipCount;
        this.yestoday.jumpRate = data.data.yesterdayDetail.jumpRate.toFixed(2);
        // this.yestoday.time = (
        //   Number(data.data.yesterdayDetail.averageStaySeconds) / 3600
        // ).toFixed(2);
        let second2 = data.data.yesterdayDetail.averageStaySeconds;
        function getTime(time) {
          // 转换为式分秒
          let h = parseInt((time / 60 / 60) % 24);
          h = h < 10 ? "0" + h : h;
          let m = parseInt((time / 60) % 60);
          m = m < 10 ? "0" + m : m;
          let s = parseInt(time % 60);
          s = s < 10 ? "0" + s : s;
          // 作为返回值返回
          return [h, m, s];
        }
        let ress = getTime(second2);
        this.yestoday.time = `${ress[0]}:${ress[1]}:${ress[2]}`;
      });
    },
    echartInit(a, b) {
      // console.log(a,b);
      this.time1 = [];
      if (a.length > 7 && a.length < 30) {
        this.time1 = [
          "0时",
          "1时",
          "2时",
          "3时",
          "4时",
          "5时",
          "6时",
          "7时",
          "8时",
          "9时",
          "10时",
          "11时",
          "12时",
          "13时",
          "14时",
          "15时",
          "16时",
          "17时",
          "18时",
          "19时",
          "20时",
          "21时",
          "22时",
          "23时",
        ];
        this.name1 = "今天浏览量(PV)";
        this.name2 = "昨天浏览量(PV)";
      } else if (a.length <= 7) {
        // console.log(this.sixtypv);
        let aa = [];
        for (const key in this.sixtypv) {
          aa.push(key);
        }
        // console.log(aa.reverse());
        aa.reverse().forEach((e, index) => {
          if (index >= 53) {
            this.time1.push(e);
          }
        });
        // this.time1 = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        // console.log(this.changpvid);
        if (this.changpvid == 1) {
          this.name1 = "本周浏览量(PV)";
          this.name2 = "上周浏览量(PV)";
        } else {
          this.name1 = "本周访客数(UV)";
          this.name2 = "上周访客数(UV)";
        }
      } else {
        if (this.changpvid == 1) {
          this.name1 = "本月浏览量(PV)";
          this.name2 = "上个月浏览量(PV)";
          // console.log(a);
        } else {
          this.name1 = "本月访客数(UV)";
          this.name2 = "上个月访客数(UV)";
        }
        let aa = [];
        for (const key in this.sixtypv) {
          aa.push(key);
        }
        aa.reverse().forEach((e, index) => {
          if (index >= 30) {
            this.time1.push(e);
          }
        });
        // this.time1 = [
        //   "一天",
        //   "两天",
        //   "三天",
        //   "四天",
        //   "五天",
        //   "六天",
        //   "七天",
        //   "八天",
        //   "九天",
        //   "十天",
        //   "十一天",
        //   "十二天",
        //   "十三天",
        //   "十四天",
        //   "十五天",
        //   "十六天",
        //   "十七天",
        //   "十八天",
        //   "十九天",
        //   "二十天",
        //   "二十一天",
        //   "二十二天",
        //   "二十三天",
        //   "二十四天",
        //   "二十五天",
        //   "二十六天",
        //   "二十七天",
        //   "二十八天",
        //   "二十九天",
        //   "三十天",
        // ];
      }
      this.$echarts.init(document.querySelector(".trendMain")).setOption({
        xAxis: {
          type: "category",
          data: this.time1,
        },
        tooltip: {
          trigger: "axis",
        },
        yAxis: {
          type: "value",
          // splitLine: {
          //   show: true,
          //   lineStyle: {
          //     type: "dashed",
          //     color: "#013A3F",
          //   },
          // },
        },
        legend: {
          data: [this.name1, this.name2],
          y: "bottom",
          itemHeight: 10, // 图例icon高度
          itemWidth: 10,
          icon: "rect",
          padding: [0, 0, 20, 0],
        },
        series: [
          {
            name: this.name1,
            stack: "Total",
            data: a,
            itemStyle: {
              color: "#1E87F0",
            },
            type: "line",
            smooth: true,
            showSymbol: false, //去掉折线上的小圆点
            //设置面积区域为渐变效果
            // 区域填充样式
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(30,135,240,0.3) ", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(255,255,255,.1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            // areaStyle: {
            //   color: this.echarts.graphic.LinearGradient(0, 1, 0, 0, [
            //     {
            //       offset: 0.4,
            //       color: "#010C17",
            //     },
            //     {
            //       offset: 1,
            //       color: "#44E2F0",
            //     },
            //   ]),
            // },
          },
          {
            name: this.name2,
            data: b,
            type: "line",
            itemStyle: {
              color: "#A5D2FF",
            },
            smooth: true,
            showSymbol: false,
          },
        ],
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  margin-top: -15px;
  ul {
    padding: 0 !important;
  }
  .trendMain {
    top: -30px;
    left: 10px;
  }
  .flex-row-start {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-top: 5px;
  }
  // background-color: #f0f2f5;
  // padding:20px;
  .Row {
    // width: 100%;
    margin: 0 10px;
    margin-bottom: 10px;
    height: 307px;
    background: #ffffff;
    box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
    border-radius: 2px;
    // margin-left: 49%;
    // transform: translateX(-50%);
    .xiaobiao {
      width: 3px;
      height: 20px;
      margin-top: 10px;
      // position: absolute;
      // bottom: 0;
      background: #1890ff;
      border-radius: 2px;
    }
    .title {
      // padding-left: 10px;
      font-size: 18px;
      // font-family: PingFangSC-Medium, PingFang SC;
      // border-left: 2px solid #1991ff;
      // border-bottom: 2px solid #1991ff;
      font-weight: 600;
      color: #24282c;
      padding: 10px 20px 5px 27px;
    }
    .hh {
      margin: 12px 30px;
      background: #eeeeee;
      height: 2px;
    }
    .main {
      display: flex;
      margin-right: -20px;
      .row-ul {
        width: 16%;
        li {
          width: 100%;
          text-align: center;
          height: 50px;
          line-height: 50px;
          font-size: 18px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #5c5c5c;
          &:nth-child(1) {
            margin-bottom: 10px;
            line-height: 30px;
          }
        }
      }
      .row-num {
        li {
          font-size: 18px;
          // font-family: HelveticaNeue;
          color: rgba(36, 40, 44, 0.75);
          &:nth-child(2) {
            font-size: 23px;
            // font-family: HelveticaNeue;
            color: rgba(36, 40, 44, 0.85);
          }
          &:nth-child(4) {
            margin-left: 13px;
            img {
              width: 16px;
              height: 16px;
              margin-left: 5px;
            }
          }
          &:nth-child(1) {
            font-size: 16px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5c5c5c;
          }
        }
      }
      .fx {
        margin-top: 70px;
        width: 1px;
        height: 152px;
        border: 1px solid #eeeeee;
      }
    }
  }
  .botton {
    display: flex;
    margin: 0 10px;
    // width: 100%;
  }
  .trend {
    /deep/.el-select .el-input .el-select__caret {
      color: #227ce2;
    }
    margin-top: 10px;
    width: 70%;
    height: 503px;
    background: #ffffff;
    box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
    border-radius: 2px;
    .xiahuaixan {
      margin: 15px 25px 5px;
      height: 2px;
      background: #eeeeee;
    }
    .heard {
      display: flex;
      margin-top: 10px;
      // padding: 1px 10px 1px 20px;
      // border-left: 2px solid #1991ff;
      justify-content: space-between;
      .xiaobiao {
        width: 3px;
        height: 20px;
        // margin-top: 10px;
        // position: absolute;
        // bottom: 0;
        background: #1890ff;
        border-radius: 2px;
      }
      /deep/.el-input__suffix {
        right: 10px;
      }
      /deep/.el-input--suffix .el-input__inner {
        padding-left: 17px;
      }
      /deep/.el-input {
        width: 42%;
      }
    }
    .title {
      // line-height: 30px;
      margin-left: 20px;
      font-size: 18px;
      // font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #24282c;
    }
    hr {
      margin: 0;
    }
    .el-select {
      left: 85px;
      font-size: 16px;
    }
    /deep/.el-input {
      width: 50%;
    }
    /deep/.el-input__inner {
      height: 25px;
      border-radius: 30px;
      color: transparent;
      text-shadow: 0 0 0 #000;
      &::placeholder {
        font-size: 15px;
        letter-spacing: 5px;
        text-align: center;
        color: #000;
      }
    }
    /deep/.el-select__caret {
      line-height: 25px;
    }
    .trend-title {
      display: flex;
      padding: 0 20px 20px 20px;
      ul {
        padding: 0;
      }
      .trend-ul {
        display: flex;
        width: 50%;
        li {
          font-size: 16px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: #5c5c5c;
          width: 85px;
          margin-left: 20px;
          height: 22px;
          line-height: 22px;
        }
        .active {
          // width: 50%;
          color: mix(#fff, #1890ff, 20%);
          // color: #298bef;
          padding-bottom: 25px;
          border-bottom: 3px solid #298bef;
        }
      }
      .right {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: end;
        .sgin {
          font-size: 14px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #5c5c5c;
          margin-right: 20px;
        }
        /deep/.el-checkbox__label {
          font-size: 14px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #5c5c5c;
        }
      }
    }
  }
  .rankli {
    margin-top: 10px !important;
    font-size: 16px;
    line-height: 30px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6f6f6f;
  }
  .HotList {
    width: 45%;
    height: 503px;
    background: #ffffff;
    box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
    border-radius: 2px;
    margin: 10px 0 0 20px;
    // padding: 1px 20px 5px 10px;
    .title {
      // line-height: 30px;
      font-size: 18px;
      margin-top: 10px;
      margin-left: 20px;
      // padding: 1px 10px 1px 10px;
      // border-left: 2px solid #1991ff;
      // font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #24282c;
    }
    .xiaobiao {
      width: 3px;
      height: 20px;
      margin-top: 10px;
      // position: absolute;
      // bottom: 0;
      background: #1890ff;
      border-radius: 2px;
    }
    .xiahuaixan {
      margin: 15px 20px 5px;
      height: 2px;
      background: #eeeeee;
    }
    // hr {
    //   margin: 0;
    // }
    .Hotlist-main {
      margin: -10px 30px;
      ul {
        padding: 0;
      }
      .hotlist-ul {
        width: 100%;
        li {
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
          .seachname {
            font-size: 20px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5c5c5c;
          }
          .rankli {
            margin-top: 10px;
            font-size: 16px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5c5c5c;
          }
          .looknum {
            font-size: 20px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5c5c5c;
            transform: scale(0.8);
          }
        }
        .top {
          margin-top: 30px;

          .seachname,
          .looknumt {
            font-size: 16px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #898989;
          }
        }
        .item-value {
          margin-right: 30px;
        }
      }
    }
  }
}
</style>
